import { isObject } from 'lodash';

import { logout } from '../lib/auth';

export default {
  currentUser(state, currentUser) {
    state.currentUser = currentUser;
  },
  TokenCoupen(state, value) {
    state.tokenCoupen = JSON.parse(JSON.stringify(value));
  },
  RemoveCoupenToken(state) {
    state.tokenCoupen = null;
  },
  notification(state, data) {
    if (isObject(data)) {
      state.snackBar.text = data.text;
      state.snackBar.color = data.color;
      state.snackBar.actionText = data.actionText;
      state.snackBar.actionCallback = data.actionCallback;
      state.snackBar.multiLine = data.multiLine;
    } else {
      state.snackBar.text = data;
      state.snackBar.color = '';
    }
    state.snackBar.show = true;
  },

  toggleSnackBar(state, show = null) {
    state.snackBar.show = show === null ? !state.snackBar.show : show;
    if (!state.snackBar.show) {
      state.snackBar.text = '';
      state.snackBar.color = '';
      state.snackBar.multiLine = false;
      state.snackBar.actionText = null;
      state.snackBar.actionCallback = null;
    }
  },

  logout(state) {
    state.currentUser = null;
    logout();
  },

  toggleDrawer(state) {
    state.drawer = !state.drawer;
  },

  setDrawerState(state, drawer) {
    state.drawer = drawer;
  },

  helpMenu(state, value) {
    state.helpMenu = value;
  },

  setSeason(state, season) {
    state.season = season;
    sessionStorage.setItem('season', JSON.stringify(season));
  },

  resetSeason(state) {
    state.season = null;
    sessionStorage.setItem('season', null);
  },

  setBreadcrumbs(state, payload) {
    state.breadcrumbs = payload;
  },

  resetBreadcrumbs(state) {
    state.breadcrumbs = [];
  },

  setVideoFeatures(state, value) {
    state.videoFeatures = value;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js